import { InputEditor } from './inputEditor';
export class InputPasswordEditor extends InputEditor {
    /** Initialize the Editor */
    constructor(args) {
        super(args, 'password');
        this.args = args;
    }
}
//# sourceMappingURL=inputPasswordEditor.js.map